import request from '@/http/http'
const PREFIX = 'api/deer';
export function getAreaTree(query) {
  return request({
    url: PREFIX + '/area/tree',
    params: query,
  })
}
export function getAreaInfo(id) {
  return request({
    url: PREFIX + '/area/' + id,
  })
}

export function createAreas(data) {
  return request({
    url: PREFIX + '/area',
    method: "post",
    data
  })
}

export function deleteAreas(id) {
  return request({
    url: PREFIX + '/area/' + id,
    method: "delete",
  })
}
export function updateArea(id, data) {
  return request({
    url: PREFIX + '/area/' + id,
    method: "put",
    data
  })
}
export function areaSearchTree(query) {
  return request({
    url: PREFIX + '/area/search/tree',
    params:query,
  })
}

export function areasSearch(query) {
  return request({
    url: PREFIX + '/area/search',
    params:query,
  })
}
export function areaSearch(id) {
  return request({
    url: PREFIX + '/area/search/'+id,
  })
}
export function areaSearchAllTree() {
  return request({
    url: PREFIX + '/area/search/all-tree',
  })
}
